import Reveal from "@/components/Reveal";

/**
 * "Monuments" — three giant editorial figures for The Gap section.
 * €0 import duty · 1 VAT registration · 1st movers.
 */
const monuments = [
  {
    n: <><em className="text-coral">€0</em></>,
    bg: "€0",
    t: "Import duty into the EU",
    b: "Ireland to Amazon's German, French, or Dutch warehouses crosses no customs border. No declarations. No duty. No fiscal representative.",
    vs: <>UK route pays <b className="text-coral">€2,000–€5,000</b> per country, per year — before selling a unit</>,
  },
  {
    n: (
      <>
        1
        <span className="text-[0.4em] tracking-[-.02em]"> reg.</span>
      </>
    ),
    bg: "27",
    t: "VAT for all 27 EU states",
    b: "One registration through Irish Revenue covers the entire union. One quarterly return. Roughly three weeks to set up.",
    vs: <>UK / US route: <b className="text-coral">separate VAT per market</b> — months of paperwork, each</>,
  },
  {
    n: (
      <>
        1<span className="text-[0.4em]">st</span>
        <em className="text-coral">.</em>
      </>
    ),
    bg: "1st",
    t: "Movers take the shelf",
    b: "Most brands in your category are not on Amazon EU yet. The first to rank organically on Amazon.de hold positions that compound for years.",
    vs: <>Organic rank, once lost, is <b className="text-coral">very expensive</b> to win back</>,
  },
];

export default function GapMonuments() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 border border-line bg-white" data-testid="gap-monuments">
      {monuments.map((m, i) => (
        <Reveal key={i} delay={i * 0.06}>
          <div
            data-testid={`gap-monument-${i}`}
            className="relative overflow-hidden px-10 py-12 border-b md:border-b-0 md:border-r border-line last:border-r-0 last:border-b-0 md:[&:nth-last-child(1)]:border-r-0"
          >
            <div
              aria-hidden="true"
              className="absolute right-[-12px] bottom-[-34px] font-serif-i italic text-ink leading-none pointer-events-none select-none"
              style={{ fontSize: "150px", opacity: 0.026, letterSpacing: "-.05em" }}
            >
              {m.bg}
            </div>
            <div className="font-serif-i italic text-ink leading-[.85] tracking-[-.05em] mb-5"
                 style={{ fontSize: "clamp(64px, 7.5vw, 108px)" }}>
              {m.n}
            </div>
            <p className="text-[15px] font-semibold text-ink mb-2.5">{m.t}</p>
            <p className="text-[13px] font-light text-ink-muted leading-[1.7] max-w-[300px]">
              {m.b}
            </p>
            <p className="mt-5 pt-4 border-t border-dashed border-line font-mono text-[10px] tracking-[0.04em] text-ink-low leading-[1.7]">
              {m.vs}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
